export enum StepEnum {
  INTRO = 'INTRO',
  SEARCH = 'SEARCH',
  LOGIN = 'LOGIN',
  PENDING = 'PENDING',
  COMPLETE = 'COMPLETE',
}
